/**
 * Classify voucher firm as Rajput (sales/chalans) or Rajdoot (labor/vendor).
 *
 * Backend voucher list contract (VoucherController):
 * - Sales / chalan invoices → firm = "Rajput Electricals"
 * - Labor / vendor invoices → firm = vendor first + last name
 *
 * So anything that is not Rajput is treated as Rajdoot (vendor labor bill).
 *
 * @param {string} firmName
 * @returns {'rajput'|'rajdoot'|'unknown'}
 */
export function classifyFirm(firmName = "") {
  const name = String(firmName || "")
    .toLowerCase()
    .trim();
  if (!name) return "unknown";
  // Match backend: sales invoices are always "Rajput Electricals"
  if (name.includes("rajput")) return "rajput";
  // Vendor name (or any other non-Rajput firm) = Rajdoot labor invoice
  return "rajdoot";
}

/**
 * Pick Rajput / Rajdoot invoice from a list of related SR invoices.
 * Unknown firms (empty firm) are assigned using preferredFirm, then fill
 * whichever side is empty — defaulting to Rajdoot (labor) first, since
 * vendor invoices are the common case when firm text is missing.
 */
export function splitServiceRequestInvoices(invoices = [], preferredFirm = "") {
  const list = (invoices || []).filter(
    inv => inv && inv.voucherType === "invoice"
  );

  let rajputInvoice =
    list.find(inv => classifyFirm(inv.firm) === "rajput") || null;
  let rajdootInvoice =
    list.find(inv => classifyFirm(inv.firm) === "rajdoot") || null;

  const unknowns = list.filter(inv => classifyFirm(inv.firm) === "unknown");
  const preferred = classifyFirm(preferredFirm);

  unknowns.forEach(inv => {
    if (preferred === "rajput") {
      if (!rajputInvoice) rajputInvoice = inv;
      else if (!rajdootInvoice) rajdootInvoice = inv;
    } else {
      // prefer rajdoot / default (vendor labor bills)
      if (!rajdootInvoice) rajdootInvoice = inv;
      else if (!rajputInvoice) rajputInvoice = inv;
    }
  });

  return { rajputInvoice, rajdootInvoice };
}

export function isInvoicePaid(invoice) {
  if (!invoice) return false;
  return (parseFloat(invoice.balance) || 0) <= 0;
}
